import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import caseCollaboratorService from "../services/case-collaborator-service";

export const caseCollaboratorSearchQuery = z.object({
	search: z.string().optional(),
	status: z.string(),
	case_record_id: z.string(),
	per_page: z.number().optional(),
	page: z.number().nullable().optional(),
});

export const caseCollaboratorsQueryOptions = (search?: z.infer<typeof caseCollaboratorSearchQuery>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case-collaborators", search],
		queryFn: () => caseCollaboratorService.list(transformSearch(search, ["case_record_id", "search", "status"])),
		...options,
	});
};

export const useCaseCollaboratorCanPostMutation = (collaboratorId?: string) => {
	return useMutation({
		mutationKey: ["case-collaborators", collaboratorId],
		mutationFn: caseCollaboratorService.updateCanPostById,
		meta: {
			successMessage: "Record updated successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["case-collaborators"] }),
	});
};
